import React from 'react';
import { BookingBelonging } from '@spike/belonging-model';
import styles from './PrintPetBelongings.module.scss';

type Props = {
    bookingBelonging?: BookingBelonging;
};

const PrintPetBelongings: React.FC<Props> = ({ bookingBelonging }) => {
    const items = bookingBelonging?.belongings ?? [];

    if (items.length === 0) {
        return null;
    }

    return (
        <div className={styles.section}>
            <div className={styles.sectionTitle}>Belongings</div>
            <ul className={styles.list}>
                {items.map((item, idx) => (
                    <li
                        key={item.id ?? idx}
                        className={styles.row}
                    >
                        <span className={styles.name}>{item.itemName}:</span> {item.quantity}
                    </li>
                ))}
            </ul>
            {bookingBelonging?.notes && (
                <div className={styles.notes}>
                    <span className={styles.name}>Notes:</span> {bookingBelonging.notes}
                </div>
            )}
        </div>
    );
};

export default PrintPetBelongings;
